import { render, staticRenderFns } from "./otherThird.vue?vue&type=template&id=727bad9f&scoped=true&"
import script from "./otherThird.vue?vue&type=script&lang=js&"
export * from "./otherThird.vue?vue&type=script&lang=js&"
import style0 from "./otherThird.vue?vue&type=style&index=0&id=727bad9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727bad9f",
  null
  
)

export default component.exports